import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useModal } from '@/hooks/use-modal';
import { useIntegrationConflicts } from '@/modules/common/hooks/use-integration-conflicts';

import { DataConflictsModal } from './data-conflicts-modal';

/**
 * Sidebar indicator for users who may see data conflicts but can't resolve them.
 * Shown only while conflicts exist; opens a modal with the administrators to contact
 * instead of navigating to Data reconciliation.
 *
 * In the collapsed sidebar the label is hidden and shown as a tooltip.
 */
export function DataConflictsIndicator() {
  const { t } = useTranslation('authenticated.settings');
  const { data: conflicts } = useIntegrationConflicts();
  const modal = useModal();

  if (!conflicts?.hasConflicts) {
    return null;
  }

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        tooltip={t('pages.integrations.dataConflicts.title')}
        onClick={modal.onOpen}
        className="text-destructive hover:text-destructive"
      >
        <AlertTriangle className="h-4 w-4 text-destructive" />
        <span>{t('pages.integrations.dataConflicts.title')}</span>
      </SidebarMenuButton>
      <DataConflictsModal
        open={modal.open}
        onOpen={modal.onOpen}
        onClose={modal.onClose}
        administrators={conflicts.administrators}
      />
    </SidebarMenuItem>
  );
}
